import { AgencyContacts } from "@/components/AgencyContacts";

export default function Contactos() {
  return (
    <div className="space-y-7">
      <div>
        <h1 className="font-heading text-3xl md:text-4xl text-ec-green">Contactos</h1>
        <p className="text-slate-500 mt-1">Notários, bancos, solicitadores e outros contactos da agência.</p>
      </div>
      <AgencyContacts />
    </div>
  );
}
